module.exports = __webpack_public_path__ + "static/story5-title-380x245-7822970234525cf3edc249d1267310a2.svg";